"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
/**
 * @param userBackground The current state of blur background toggle
 * @returns {(function(*): void)|*}
 */
function setUserBackground(userBackground) {
  return (0, _utils.actionCreator)(_types.SET_BACKGROUND_OPTION, {
    userBackground: userBackground
  });
}
var _default = exports["default"] = setUserBackground;